import { Runtime } from '$store/runtime.ts'
import { signal } from '@preact/signals'
import type { Suggestion } from 'apps/commerce/types.ts'
import { debounce } from 'std/async/debounce.ts'
import { mergeAlgoliaProductsWithVtex, sanitizeSearchProducts } from 'site/utils/algoliaInsights.ts'

const payload = signal<Suggestion | null>(null)
const loading = signal<boolean>(false)

const suggestionsAlgolia = Runtime.algolia.loaders.product.suggestions
const suggestionsVtex = Runtime.vtex.loaders.intelligentSearch.suggestions

const vtexLoader = Runtime.vtex.loaders.legacy.productList

const setSearch = debounce(async (search: string, count: number, algolia?: boolean) => {
    try {
      if(algolia) {
          const response = await suggestionsAlgolia({ query: search, count, hideUnavailable: true })
          const algoliaProducts = response?.products ?? []
          const ids = algoliaProducts.map((product) => product.inProductGroupWithID!) ?? []
    
          const vtexResponse = await vtexLoader({ props: { productIds: ids } })
          const products = sanitizeSearchProducts(
              mergeAlgoliaProductsWithVtex(
                  algoliaProducts,
                  vtexResponse?.filter(Boolean) ?? [],
              ),
          )

          payload.value = {
            searches: response?.searches ?? [],
            products,
          }
      } else {
        const response = await suggestionsVtex({ query: search, count })
        payload.value = response
            ? {
                ...response,
                products: sanitizeSearchProducts(response.products ?? []),
            }
            : response
      }
    } catch (error) {
        console.error('Something went wrong while fetching suggestions \n', error)
    } finally {
        loading.value = false
    }
}, 250)

const state = {
    setSearch: (query: string, count = 4, algolia?: boolean) => {
        loading.value = true
        setSearch(query, count, algolia)
    },
    loading,
    suggestions: payload,
}

/**
 * This hook only works if the vtex intelligent search app is installed at VTEX Account.
 */
export const useAutocomplete = () => state
